import type { SVGProps } from "react";

export function OpeningQuote(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 12.557C5.591 12.212 6.268 12 7 12C9.206 12 11 13.794 11 16C11 18.206 9.206 20 7 20C4.794 20 3 18.206 3 16V10C3 6.691 5.691 4 9 4H10V6H9C6.794 6 5 7.794 5 10V12.557ZM5 16C5 17.103 5.897 18 7 18C8.103 18 9 17.103 9 16C9 14.897 8.103 14 7 14C5.897 14 5 14.897 5 16Z"
                fill={props.fill ?? "#6E767D"}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 12.557C15.591 12.212 16.268 12 17 12C19.206 12 21 13.794 21 16C21 18.206 19.206 20 17 20C14.794 20 13 18.206 13 16V10C13 6.691 15.691 4 19 4H20V6H19C16.794 6 15 7.794 15 10V12.557ZM15 16C15 17.103 15.897 18 17 18C18.103 18 19 17.103 19 16C19 14.897 18.103 14 17 14C15.897 14 15 14.897 15 16Z"
                fill={props.fill ?? "#6E767D"}
            />
        </svg>
    );
}
